import { Model as e } from "../../../../../model.js";
class d extends e {
  constructor(s) {
    super(), this.address = s.address, this.addressExtra = s.addressExtra, this.latitude = s.latitude, this.longitude = s.longitude, this.fullAdress = s.fullAdress;
  }
}
export {
  d as ShopSessionDropOffModel
};
//# sourceMappingURL=dropOff.model.js.map
